import { render, staticRenderFns } from "./Muvofiqlashtiruvchi.vue?vue&type=template&id=081feed2&scoped=true&"
import script from "./Muvofiqlashtiruvchi.vue?vue&type=script&lang=js&"
export * from "./Muvofiqlashtiruvchi.vue?vue&type=script&lang=js&"
import style0 from "./Muvofiqlashtiruvchi.vue?vue&type=style&index=0&id=081feed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081feed2",
  null
  
)

export default component.exports